<template>
	<div class="container address">
        <div class="row">
            <div class="col-4 icon-master">
                <i class="fa fa-clock"></i>
            </div>

            <div class="col-8">
                <div class="headline h2 tc">
                    <span>Wann kann der Probetermin stattfinden?</span>
                </div>
                <div class="tc">
                    <p>Für den Probetermin berechnen wir einmalig 22,50 €. Der Probetermin findet am angegebenen Nachhilfeort statt und dient neben einem ersten Kennenlernen auch der Verortung der Defizite.</p>
                    <p>Bitte gib den gewünschten Beginn der Nachhilfestunde an. Diese dauert dann 60 Minuten.</p><br>
                </div>
                
                <div class="row" >
                    <div class="input-group col-12" >
                        <datetime v-model="dateOne" :min-datetime="minDateTime" :minute-step="15" type="datetime"  placeholder="Terminvorschlag 1" v-validate="'required'" :phrases="{ok: 'Ok', cancel: 'Abbrechen'}" v-bind:class="{'error':(showErrors && dateOne=='')}"></datetime>
                    </div>
                    <div class="input-group col-12">
                        <datetime v-model="dateTwo" :min-datetime="minDateTime" :minute-step="15" type="datetime"  placeholder="Terminvorschlag 2" v-validate="'required'" :phrases="{ok: 'Ok', cancel: 'Abbrechen'}" v-bind:class="{'error':(showErrors && dateTwo=='')}" ></datetime>
                    </div>
                    <div class="input-group col-12">
                        <datetime v-model="dateThree" :min-datetime="minDateTime" :minute-step="15" type="datetime"  placeholder="Terminvorschlag 3 (optional)" :phrases="{ok: 'Ok', cancel: 'Abbrechen'}" ></datetime>
                        <button @click="resetDateThree()" v-if="dateThree!=''" class="delete" >×</button>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import { Datetime } from 'vue-datetime'

export default {
	name: 'dateData',
	components: {
		datetime: Datetime
	},

   data: function () {
    return {
      showErrors: false,
      dateOne: '',
      dateTwo: '',
      dateThree: '',

      minDateTime: new Date().toISOString(),
    }
  },

  mounted() {

  },

  methods: {
      nextPage() {
          this.$validator.validateAll().then((result) => {
              if (result) {
                  // Success
                  this.$emit('openNextPage', this);
                  return;
              }
              if(!result){
                // Error
                this.showErrors = true;
              }
          });
      },
      resetDateThree() {
        this.dateThree = "";
      }
    }
}
</script>

<style lang="less">
.vdatetime.error {
    input {
        border-color: #AB0000;
    }
}
div.vdatetime-popup__actions__button, div.vdatetime-time-picker__item--selected, div.vdatetime-month-picker__item--selected, div.vdatetime-year-picker__item--selected {
  color: #4d9aa2;
}
div.vdatetime-popup__header, div.vdatetime-calendar__month__day--selected > span > span, div.vdatetime-calendar__month__day--selected:hover > span > span {
  background: #4d9aa2;
}
.vdatetime-popup__body {
  overflow: auto;
  max-height: 55vh;
}
</style>